import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import DailyBriefingIllustration from "assets/images/DailyBriefingIllustration.png";
import type { dailyBrief } from "store/types/news";

type Props = {
  briefing: dailyBrief | null;
  onOpenFull?: () => void;
};

export const BriefingCard: React.FC<Props> = ({ briefing, onOpenFull }) => {
  const renderBody = () => {
    if (briefing?.highlights?.length) {
      return (
        <Box
          component="ul"
          sx={{
            m: 0,
            pl: 0,
            width: "100%",
            listStyle: "disc",
            color: "#92A7BC",
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 400
          }}
        >
          {briefing.highlights.map((highlight, i) => (
            <Box component="li" key={i} sx={{ marginInlineStart: "24px" }}>
              {highlight}
            </Box>
          ))}
        </Box>
      );
    }
    if (briefing?.summary) {
      return (
        <Typography
          sx={{
            fontSize: "16px",
            lineHeight: "24px",
            color: "#92A7BC",
            whiteSpace: "pre-wrap"
          }}
        >
          {briefing.summary}
        </Typography>
      );
    }
    return (
      <Typography sx={{ fontSize: "16px", lineHeight: "24px", color: "#92A7BC" }}>
        No briefing available yet. Use Feed Settings to configure topics.
      </Typography>
    );
  };

  return (
    <Box
      onClick={onOpenFull}
      sx={{
        mb: "16px",
        display: "flex",
        alignItems: "stretch",
        gap: "24px",
        p: "24px",
        minHeight: "239px",
        borderRadius: "8px",
        bgcolor: "#071F35",
        overflow: "hidden",
        cursor: onOpenFull ? "pointer" : "default"
      }}
    >
      <Stack flex={1} minWidth={0} gap="8px" justifyContent="center">
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "16px",
            color: "#26A6AE",
            textTransform: "uppercase",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}
        >
          Daily briefing
        </Typography>
        {renderBody()}
      </Stack>
      <Box
        sx={{
          flexShrink: 0,
          width: "248px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Box sx={{ position: "relative", width: "214px", height: "191px", overflow: "hidden", flexShrink: 0 }}>
          <Box
            component="img"
            src={DailyBriefingIllustration}
            alt=""
            sx={{
              position: "absolute",
              left: 0,
              top: "-6.71%",
              width: "100%",
              height: "112.26%",
              maxWidth: "none",
              pointerEvents: "none",
              display: "block"
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
